import { mainApiAxios as axios } from '@/plugins/axios'

export default {

    listPlanTaskExecutionMethods() {
        return axios.get('lookups/plan-tasks/execution-methods')
    },

    listPlanTaskProcessTypes() {
        return axios.get('lookups/plan-tasks/process-types')
    },

    listProcessTypes() {
        return axios.get('lookups/process-types')
    },

    listFileTypeCategories() {
        return axios.get('lookups/file-type-categories')
    },

    listPlanTaskTypes() {
        return axios.get('lookups/plan-tasks/types')
    },

    listCommentCategories() {
        return axios.get('lookups/comments/categories')
    },

    listLetterTemplates() {
        return axios.get('lookups/letter-templates')
    },

    listAdminLetterTemplates() {
        return axios.get('lookups/admin-letter-templates')
    },

    listLetterTemplatesByTaskId(taskId) {
        return axios.get(`lookups/letters/templates?activityInstanceId=${taskId}`)
    },

    loadDefaultTitle(taskId) {
        return axios.get(`lookups/default-title?activityInstanceId=${taskId}`)
    },

    loadDefaultTitleByProcessId(processTypeId) {
        return axios.get(`lookups/process/default-title?processTypeId=${processTypeId}`)
    },

    listRiskTypes() {
        return axios.get('lookups/risks/risk-types')
    },

    listRiskScoreAverages() {
        return axios.get('lookups/risks/risk-score-averages')
    },

    listRiskClassifications() {
        return axios.get('lookups/risks/risk-classifications')
    },

    listStrategicGoals() {
        return axios.get('lookups/strategy/strategic-goals')
    },

    listInitiatives() {
        return axios.get('lookups/strategy/initiatives')
    },

    listProjects() {
        return axios.get('lookups/strategy/projects')
    },

    listCoreMissions() {
        return axios.get('lookups/strategy/core-missions')
    },

    listCoreVisions() {
        return axios.get('lookups/strategy/core-visions')
    },

    listCoreValues() {
        return axios.get('lookups/strategy/core-values')
    },

    listStrategicAims() {
        return axios.get('lookups/strategy/strategic-aims')
    },

    listFormFields(formId) {
        return axios.get(`lookups/form-fields?formId=${formId}`)
    },

    listElibraryCategories() {
        return axios.get('lookups/elibrary-categories')
    },

    listStructureTypes() {
        return axios.get('lookups/structure-types')
    },

    listStructures() {
        return axios.get('lookups/structures')
    },

    listInternalStructures() {
        return axios.get('lookups/internal-structures')
    },

    listPlanStructures() {
        return axios.get('lookups/plan-structures')
    },

    listRoles() {
        return axios.get('lookups/roles')
    },

    listLanguages() {
        return axios.get('lookups/languages')
    },

    listDatasources() {
        return axios.get('lookups/data-sources')
    },

    listDataTables(connectionId) {
        return axios.get(`lookups/data-tables?connectionId=${connectionId}`)
    },

    listDataFields(connectionId, tableName) {
        return axios.get(`lookups/data-fields?connectionId=${connectionId}&tableName=${tableName}`)
    },

    listMappings() {
        return axios.get('lookups/mappings')
    },

    listProcessStatuses() {
        return axios.get('lookups/process-statuses')
    },

    listDataTypes() {
        return axios.get('lookups/data-types')
    },

    listOwnerTypes() {
        return axios.get('lookups/owner-types')
    },

    listRolesForAutoComplete(search) {
        return axios.get(`lookups/roles?search=${search}&mode=Autocomplete`)
    },

    listProcessInstancesForAutoComplete(search) {
        return axios.get(`lookups/processInstances?search=${search}&mode=Autocomplete`)
    },

    listExecutionWays() {
        return axios.get('lookups/execution-ways')
    },

    getRoleById(roleId) {
        return axios.get(`lookups/roles/${roleId}`)
    },

    getUserById(userId) {
        return axios.get(`lookups/users/${userId}`)
    },

    getDepartmentById(departmentId) {
        return axios.get(`lookups/departments/${departmentId}`)
    },

    listRoles(search) {
        return axios.get(`lookups/roles?search=${search}&mode=List`)
    },

    listPriorities() {
        return axios.get('lookups/priorities')
    },

    listBonds() {
        return axios.get('lookups/bonds')
    },

    listRoleTypes() {
        return axios.get('lookups/role-types')
    },

    listTemplateCategories() {
        return axios.get('lookups/template-categories')
    },

    listLetterSignLevels() {
        return axios.get('lookups/sign-levels')
    },

    listLetterStatuses() {
        return axios.get('lookups/letter-statuses')
    },

    listCommentStages() {
        return axios.get('lookups/comment-stages')
    },

    listProcessStages() {
        return axios.get('lookups/process-stages')
    },
    
    listAccountTypes() {
        return axios.get('lookups/account-types')
    },

    listMissionFileTypes(categoryId) {
        return axios.get(`lookups/file-types?categoryId=${categoryId}`)
    },

    listCommentAgreements() {
        return axios.get('lookups/comment-agreements')
    },

    listCommentDecisionTypes() {
        return axios.get('lookups/comment-decision-types')
    },
    listGenericReplyRequestTypes() {
        return axios.get('lookups/request-types')
    },
    listPermissionLevels() {
        return axios.get('lookups/permission-levels')
    },

    listFinancialProcessTypes() {
        return axios.get('lookups/financial-process-types')
    },

    listProcessStructures(financialProcessTypeId) {
        return axios.get(`lookups/financial-process-structures/${financialProcessTypeId}`)
    },

    listOccurenceTypes() {
        return axios.get('lookups/occurence-types')
    },
}